import { render, staticRenderFns } from "./BoxLearnedWordsChart.vue?vue&type=template&id=5094c76e&"
import script from "./BoxLearnedWordsChart.vue?vue&type=script&lang=js&"
export * from "./BoxLearnedWordsChart.vue?vue&type=script&lang=js&"
import style0 from "./BoxLearnedWordsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports